import { Card, CardContent, CardHeader, CardHeaderProps } from '@mui/material';
import { StoreResult } from 'api/client-domain/client-domain.types';
import RelatedLocationAvatar from './related-location-avatar/related-location-avatar.component';
import RelatedLocationHeader from './related-location-header/related-location-header.component';
import RelatedLocationSubheader from './related-location-subheader/related-location-subheader.component';

type RelatedLocationCardProps = {
  relatedLocation: Partial<StoreResult>;
  cardHeaderProps?: CardHeaderProps;
  onNavigate: (id: string) => void;
  'data-testid'?: string;
};

export const RelatedLocationCard = ({
  relatedLocation,
  cardHeaderProps,
  onNavigate,
  'data-testid': dataTestId,
}: RelatedLocationCardProps) => {
  return (
    <Card
      sx={{ cursor: 'pointer' }}
      onClick={() => onNavigate(relatedLocation?.storeId)}
      data-testid={dataTestId}
    >
      <CardHeader
        avatar={<RelatedLocationAvatar relatedLocation={relatedLocation} />}
        title={<RelatedLocationHeader relatedLocation={relatedLocation} />}
        sx={{ paddingBottom: 0 }}
        {...cardHeaderProps}
      />
      <CardContent sx={{ pb: '8px !important', pt: '8px' }}>
        <RelatedLocationSubheader relatedLocation={relatedLocation} />
      </CardContent>
    </Card>
  );
};

export default RelatedLocationCard;
